import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Search from "../views/Search.vue";
import Conversation from "../views/Conversation.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/search",
    name: "Search",
    component: Search
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },
  {
    path: "/user",
    name: "User",
    component: () => import(/* webpackChunkName: "user" */ "../views/User.vue")
  },
  {
    path: "/conversation",
    name: "Conversation",
    component: Conversation
  },
  {
    path: "/company",
    name: "Company",
    component: () => import(/* webpackChunkName: "company" */ "../views/Company.vue")
  },
  {
    path: "/wallet",
    name: "Wallet",
    component: () => import(/* webpackChunkName: "user" */ "../views/Wallet.vue")
  },
  {
    path: "/detail",
    name: "Detail",
    component: () => import(/* webpackChunkName: "detail" */ "../views/Detail.vue")
  },
  {
    path: "/redDetail",
    name: "RedDetail",
    component: () => import(/* webpackChunkName: "redDetail" */ "../views/RedDetail.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  routes
  // scrollBehavior(to, from, savedPosition) {
  //   if (to.name === "Home" && savedPosition === null) {
  //     return { x: 0, y: 99999 };
  //   }
  //   if (savedPosition) {
  //     return savedPosition;
  //   } else {
  //     return { x: 0, y: 0 };
  //   }
  // }
});

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default router;
